import { render, staticRenderFns } from "./addContract.vue?vue&type=template&id=6a9c6440&scoped=true"
import script from "./addContract.vue?vue&type=script&lang=js"
export * from "./addContract.vue?vue&type=script&lang=js"
import style0 from "./addContract.vue?vue&type=style&index=0&id=6a9c6440&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c6440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9c6440')) {
      api.createRecord('6a9c6440', component.options)
    } else {
      api.reload('6a9c6440', component.options)
    }
    module.hot.accept("./addContract.vue?vue&type=template&id=6a9c6440&scoped=true", function () {
      api.rerender('6a9c6440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/addContract.vue"
export default component.exports